import { Typography } from "antd";
import { TextProps } from "antd/es/typography/Text";
import { ReactNode } from "react";

type SettingsLabelProps = {
  children: ReactNode;
} & TextProps;

export const SettingsLabel = ({
  children,
  style,
  type,
  ...rest
}: SettingsLabelProps) => {
  return (
    <Typography.Text
      style={{
        fontSize: type === "secondary" ? 12 : 14,
        fontWeight: type === "secondary" ? 400 : 500,
        ...style,
      }}
      {...rest}
    >
      {children}
    </Typography.Text>
  );
};
